<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5 12H12M19 12H12M12 12V5M12 12V19" stroke="#1B262C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
